import { useMutation } from '@tanstack/react-query'

import { ReservationDto } from '@wwt/entities/api/search-response'

import { CANCEL_RESERVATION_KEY } from '../config/cancelReservationKey'
import { reservationCancelQuery } from '../query/reservationCancelQuery.ts'

export const useCancelReservation = () => {
	const mutation = useMutation({
		mutationKey: [CANCEL_RESERVATION_KEY],
		mutationFn: async (reservationId: ReservationDto['reservationId']) => {
			return await reservationCancelQuery(reservationId)
		}
	})

	return mutation
}
